import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { t } from '@lingui/core/macro';
import type { MenuItemsType } from '@duke-hq/ui/components/SubSidebar/MenuItems';
import { SidebarLayout } from '@duke-hq/ui/components/SubSidebar/SidebarLayout';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { Inbox, ListTodo, CheckCheck, XCircle, LayoutDashboard } from 'lucide-react';
import { constructQueryParams } from '@duke-hq/lib';
import { withPermission } from '../withPermission';

function generateMenuItems(): MenuItemsType[] {
  const baseUrl = '/assessments';
  return [
    {
      label: t`Dashboard`,
      link: `${baseUrl}/dashboard`,
      icon: LayoutDashboard,
      showDivider: true,
    },
    {
      label: t`All`,
      link: `${baseUrl}${constructQueryParams({ page: '1' })}`,
      icon: ListTodo,
      criteria: ['outcome'],
    },
    {
      label: t`Pending`,
      link: `${baseUrl}${constructQueryParams({ outcome: 'PENDING', page: '1' })}`,
      icon: Inbox,
      criteria: ['outcome'],
    },
    {
      label: t`Satisfactory`,
      link: `${baseUrl}${constructQueryParams({ outcome: 'SATISFACTORY', page: '1' })}`,
      icon: CheckCheck,
      criteria: ['outcome'],
    },
    {
      label: t`Not Yet Satisfactory`,
      link: `${baseUrl}${constructQueryParams({ outcome: 'NOT_YET_SATISFACTORY', page: '1' })}`,
      icon: XCircle,
      criteria: ['outcome'],
    },
  ];
}

export const AssessmentsLayout = withPermission('canViewAssessments', () => {
  const { data: snapshot } = trpcAdmin.assessments.snapshot.useQuery();

  const updatedSidebarMenuItems = useMemo(() => {
    const sidebarMenuItems = generateMenuItems();

    return sidebarMenuItems.map((item) => {
      // Only add snapshot value if it exists in the snapshot data
      if (snapshot && typeof snapshot === 'object' && item.label in snapshot) {
        const snapshotValue = (snapshot as Record<string, unknown>)[item.label];
        return {
          ...item,
          snapshot: typeof snapshotValue === 'number' ? snapshotValue : undefined,
        };
      }
      return item;
    });
  }, [snapshot]);

  return (
    <SidebarLayout items={updatedSidebarMenuItems} label={t`Assessments`}>
      <Outlet />
    </SidebarLayout>
  );
});
